import React from "react";
import HoursLogo from "../../Photos/hours-logo.svg"
import "./Hours.scss"
import Conceptual from "../../SVGElements/CONCEPTUAL TA HOURS.svg"
import Debugging from "../../SVGElements/DEBBUGING TA HOURS.svg"
import { SectionProps } from "../../App";

interface HoursProps {}

export class Hours extends React.Component<SectionProps> {
    render() {
        return (
          <section
            id="hours"
            className={`anchor hours ${this.props.static ? "static" : ""}`}
          >
            <div className="header-container">
              <div className="content-container hours"></div>
              <img
                className="hours-logo logo"
                src={HoursLogo}
                alt="hours text"
              />
              {/* <div className="description gcal">
                <p>
                  Confused about your code, and unsure if it a conceptual
                  misunderstanding or just a setup issue? Project hours are the
                  first phase of our TA hours that are meant to get students
                  comfortable with Java syntax and intro Java concepts for the
                  first few projects so you can build a strong foundation on the
                  basics of CS.
                </p>
                <p>
                  Click on the timeslot you are looking to attend in order to
                  see which room it is in!
                </p>
              </div> */}
              {/* <div className="iframe-container">
                <iframe
                  src="https://calendar.google.com/calendar/embed?src=c_223965767e42472e84863506b265c3adb1ff7ff02b484c019882580d912fcb78%40group.calendar.google.com&ctz=America%2FNew_York&mode=MONTH"
                  style={{ border: 0 }}
                  width="800"
                  height="2000"
                ></iframe>
              </div> */}
              <div className="hours-description">
                <center>
                  <img
                    className="resources-title-svg"
                    src={Conceptual}
                    style={{ margin: "0px" }}
                  />
                </center>
                <p style={{ margin: "0px" }}>
                  Confused about an idea discussed in lecture or in a project
                  handout? If we don't have to look at your code to answer your
                  question, conceptual hours are a great place to meet other
                  students and talk to a TA. Your question will get answered
                  much faster here than at the debugging hours line. Note that
                  laptops are not allowed in conceptual hours - if you have a
                  specific question about your code, please go to debugging
                  hours.
                </p>
                <p>
                  Click on the timeslot you are looking to attend in order to
                  see which room it is in!
                </p>
              </div>{" "}
              <div className="iframe-container" style={{ padding: "0px" }}>
                <iframe
                  src="https://calendar.google.com/calendar/embed?src=c_223965767e42472e84863506b265c3adb1ff7ff02b484c019882580d912fcb78%40group.calendar.google.com&ctz=America%2FNew_York&mode=MONTH"
                  style={{ border: 0 }}
                  width="800"
                  height="600"
                ></iframe>
              </div>{" "}
              <div className="hours-description">
                <center>
                  <img
                    className="resources-title-svg"
                    src={Debugging}
                    style={{ margin: "0px" }}
                  />
                </center>
                <p style={{ margin: "0px" }}>
                  Debugging Hours are a great resource to discuss 1-on-1 with a
                  TA about your code and learn how to solve your bugs; however,
                  please be sure to check our TA Hours policy and the Ed page
                  before getting in line at{" "}
                  <a href="https://hours.cs.brown.edu/">the hours website</a>.
                  When waiting for hours, wait near CIT 210 and a TA will come
                  to get you!
                </p>
                <p>
                  Click on the timeslot you are looking to attend in order to
                  see which room it is in!
                </p>
              </div>{" "}
              <div className="iframe-container" style={{ padding: "0px" }}>
                <iframe
                  src="https://calendar.google.com/calendar/embed?src=c_3a8c4babef95e0da0c93ffe726da02558780f2674f8c7868e3631edb2a0b2fca%40group.calendar.google.com&ctz=America%2FNew_York"
                  style={{ border: 0 }}
                  width="800"
                  height="600"
                ></iframe>
              </div>
            </div>
          </section>
        );
    }
}
